import CommonTitleBar from "components/common/CommonTitleBar";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import WorkshopCard from "./WorkshopCard";
import NoDataFound from "components/common/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllWorkspaces,
  getEnableDisableSpaceStatus,
  updateEnableDisableSpaceStatus,
} from "store/actions/workspaceSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";
import Paginations from "components/common/Paginations";
import { ShimmerContentBlock } from "react-shimmer-effects";
import WorkshopShimmer from "components/ShimmerEffects/WorkshopShimmer";
import {
  orderByOptions,
  statusOptions,
  workShopStatusTypes,
} from "components/constants/StatusKeys";
import FiltersWithoutSearch from "components/common/FiltersWithoutSearch";
import { InputSwitch } from "primereact/inputswitch";
import eye from "assets/images/icons/eye.svg";
import orderChange from "assets/images/icons/orderChange.svg";
import {
  resetWorkspaceFilterState,
  updateWorkspaceFilterState,
} from "store/reducers/workspaceReducer";
import { formatFilterOptions, getMinMaxDate } from "components/common/Utils";
import Filters from "components/common/Filters";
import { getOrganistionList } from "store/actions/organizationSlice";

const Workshop = () => {
  const { t } = useTranslation();
  document.title = t("Workshop | Work Space");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    workspaces: workshops,
    drafts,
    unavailable,
    archived,
    perPage,
    totalCount,
    totalPages,
    currentPage,
    spaceStatus,
    currentSpaceStatus,
    workspaceFilters,
  } = useSelector((state) => state.Workspace);

  const matchedSpace = currentSpaceStatus?.find(
    (space) => space.name === "workShop"
  );
  const { keyword, selectedFilters, dates } = workspaceFilters;
  const { organisationsList } = useSelector((state) => state.Organizations);

  const [displayOrder, setDisplayOrder] = useState(null);

  useEffect(() => {
    if (matchedSpace) {
      setDisplayOrder(matchedSpace.displayOrder);
    }
  }, [matchedSpace]);

  useEffect(() => {
    getAllData();
    dispatch(getOrganistionList());
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const { orderBy, status, organizationId, branches } = selectedFilters;
    const isReset = actionType === "RESET";

    const payload = {
      spaceTypeInt: 3, // Space Type Int [1-workSpace , 2-meetingRoom , 3-workShop]
      perPage: perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      keyword: isReset ? "" : keyword,
      dateRange: isReset ? {} : getMinMaxDate(dates),
      branches: isReset ? [] : branches,
      organizationId: isReset ? "" : organizationId,
    };
    dispatch(getAllWorkspaces(payload));
    dispatch(getEnableDisableSpaceStatus());
    navigate(`/bookings/workshops?page=${page || pageNumber}`);
  };

  const searchfilters = [
    // {
    //   key: "status",
    //   placeholder: "Status",
    //   options: statusOptions,
    //   type: "singleSelect",
    // },
    // {
    //   key: "orderBy",
    //   placeholder: "Order By",
    //   options: orderByOptions,
    //   type: "singleSelect",
    // },
    {
      key: "organizationId",
      placeholder: "Organisation",
      options: formatFilterOptions(organisationsList),
      type: "singleSelect",
    },
    {
      key: "branches",
      type: "branchCityFilter",
    },
  ];

  const handleReset = () => {
    dispatch(resetWorkspaceFilterState());
    getAllData(1, { actionType: "RESET" });
  };

  const updateSpaceStatus = (id, isHide, newOrder) => {
    const payload = {
      id,
      displayOrder: newOrder,
      isHide,
    };
    dispatch(updateEnableDisableSpaceStatus(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(
            showAlert({ text: "Status updated Successfully!", type: "success" })
          );
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };
  const setKeyword = (value) =>
    dispatch(updateWorkspaceFilterState({ keyword: value }));
  const setDates = (value) =>
    dispatch(updateWorkspaceFilterState({ dates: value }));
  const setSelectedFilters = (value) => {
    const updatedFilters =
      typeof value === "function" ? value(selectedFilters) : value;
    dispatch(updateWorkspaceFilterState({ selectedFilters: updatedFilters }));
  };

  return (
    <React.Fragment>
      <div className="page-content common_page workshop_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Workshops")}
            isCreateBtn={true}
            createBtnText={t("Add New")}
            onCreateBtnClick={() => navigate("/bookings/workshops/add-new")}
          />

          <div className="common_filter_wrapper row my-4">
            <Filters
              keyword={keyword}
              setKeyword={setKeyword}
              onSearch={getAllData}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              dates={dates}
              setDates={setDates}
              filters={searchfilters}
              // setDates={(value) => dispatch(setDates(value))}
              onReset={handleReset}
            />
          </div>
          <div className="common_space_app_settings row">
            <div className="col-lg-6">
              <label htmlFor="">
                <img src={eye} width={15} height={15} className="me-2" alt="" />
                {t("Show in App")}
              </label>
              <div className="checkbox_div">
                <InputSwitch
                  checked={!matchedSpace?.isHide ?? false} // use matchedSpace
                  onChange={() => {
                    if (!matchedSpace) return;

                    // Toggle isHide and send current displayOrder
                    updateSpaceStatus(
                      matchedSpace._id,
                      !matchedSpace.isHide,
                      matchedSpace.displayOrder
                    );
                  }}
                />
                <h2 className="fs_16 ms-2">
                  {t(
                    "Turn on to display the “Workshops” page in the app. Turn off to hide it"
                  )}
                </h2>
              </div>
            </div>

            <div className="col-lg-6">
              <label htmlFor="">
                <img
                  src={orderChange}
                  width={15}
                  height={15}
                  className="me-2"
                  alt=""
                />
                {t("Display Order in App")}
              </label>
              <div className="">
                <select
                  value={displayOrder} // use state
                  onChange={(e) => {
                    const newOrder = Number(e.target.value);
                    setDisplayOrder(newOrder);
                    if (!matchedSpace) return;

                    updateSpaceStatus(
                      matchedSpace._id,
                      matchedSpace.isHide,
                      newOrder
                    );
                  }}
                >
                  {[1, 2, 3, 4, 5].map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
                <p className="short_desc">
                  {t(
                    "Choose the position of this page in the app menu. 1 shows first, higher numbers appear later"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="common_wrapper">
            <div className="">
              {/* <FiltersWithoutSearch
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                filters={searchfilters}
                onSearch={getAllData}
                onReset={handleReset}
                className="filter_2"
                isDateRange={false}
                showSearchButton={false}
              /> */}
            </div>

            <div className="workshop_row">
              {loading ? (
                <WorkshopShimmer />
              ) : selectedFilters.status === 4 ? (
                unavailable?.length === 0 ? (
                  <NoDataFound text={t("No unavailable workshops")} />
                ) : (
                  unavailable?.map((item) => (
                    <WorkshopCard
                      key={item?._id}
                      item={item}
                      isLoading={isLoading}
                    />
                  ))
                )
              ) : selectedFilters.status === 5 ? (
                archived?.length === 0 ? (
                  <NoDataFound text={t("No archived workshops")} />
                ) : (
                  archived?.map((item) => (
                    <WorkshopCard
                      key={item?._id}
                      item={item}
                      isLoading={isLoading}
                    />
                  ))
                )
              ) : workshops?.length === 0 ? (
                <NoDataFound text={t("No workshops found")} />
              ) : (
                workshops?.map((item) => (
                  <WorkshopCard
                    key={item?._id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </div>
          </div>

          {selectedFilters.status !== 4 && selectedFilters.status !== 5 && (
            <>
              <h2 className="main_title">{t("Draft")}</h2>
              <div className="common_wrapper">
                {loading ? (
                  <WorkshopShimmer />
                ) : drafts?.length === 0 ? (
                  <NoDataFound text={t("No drafts saved yet")} />
                ) : (
                  <div className="workshop_row">
                    {drafts?.map((item) => (
                      <WorkshopCard
                        key={item?.id}
                        item={item}
                        className="draft"
                        isLoading={isLoading}
                      />
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Workshop;
